import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
/*Service */
import { AppService } from '@services';
/*Config*/
import { CONFIG } from '../../../config';


@Component({
  selector: 'timer-add',
  templateUrl: './timer-add.component.html'
})
export class TimerAddComponent implements OnInit {
  @Output('onAddTimer') onAddTimer: EventEmitter<any> = new EventEmitter<any>();
  @Input() typeTimer;
  @Input() ifCurrentPandora;

  constructor(
    private appService: AppService
  ) { }
  isShow = false;
  currentTime;
  dayOfWeek = 0;
  period;
  periodTimer = CONFIG.periodTimer;
  weekTimer = CONFIG.weekTimer;
  ngOnInit() {
    if (this.ifCurrentPandora) {
      this.periodTimer = CONFIG.periodTimerPandora;
    }

  }

  getCurrentTime() {
    const date = new Date();
    let hours = date.getHours().toString();
    let minutes = date.getMinutes().toString();
    if (hours.length === 1) {
      hours = '0' + hours;
    }
    if (minutes.length === 1) {
      minutes = '0' + minutes;
    }
    this.currentTime = hours + ':' + minutes;
  }
  show() {
    this.getCurrentTime();
    this.isShow = true;
    this.period = this.periodTimer[0].value;
  }

  add() {
    const userDateTimeOffset = this.appService.userTimezoneOffset();
    let hours = parseInt(this.currentTime.split(':')[0]);
    const minutes = parseInt(this.currentTime.split(':')[1]);
    if (userDateTimeOffset < 0) {
      hours = hours + userDateTimeOffset;
    } else {
      hours = hours - userDateTimeOffset;
    }

    if (hours < 0) {
      hours = hours + 24;
    }
    this.hide();

    const body = {
      'dayOfWeek': this.dayOfWeek,
      'hours': hours,
      'minutes': minutes,
      'period': this.period,
      'type': this.typeTimer
    };
    this.onAddTimer.emit(body);
  }
  hide() {
    this.isShow = false;
  }
  selectDay(event, value) {
    this.dayOfWeek = value;
  }

}



// WEBPACK FOOTER //
// ./src/app/view/components/timer-add/timer-add.component.ts